// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"3ffb39ba","127":"d3c7ac3c","169":"d3c7ac3c","440":"d3c7ac3c","593":"d3c7ac3c","667":"d3c7ac3c","735":"37ca66e6","742":"9f47e77b","845":"47ec3ed2","857":"d3c7ac3c","941":"d3c7ac3c","958":"9f47e77b"}[chunkId] + ".chunk.css";
};